/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 云剧院模块首页推荐视频新接口
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cloundtheater.VideoDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cloundtheater/videos/recommend/new`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
